import React, { lazy, Suspense } from 'react';

const ParagraphPopup = lazy(() => import('./index.lazy'));

const renderLoader = () => <p>Loading</p>;

const ParagraphPopupSuspense = (props) => (
  <Suspense fallback={renderLoader()}>
    <ParagraphPopup {...props} />
  </Suspense>
);

export default ParagraphPopupSuspense;
